import type { FeedRow } from "../types";
import type { FeedEvent, FeedSubmission } from "./feed-records";
export function eventRow({
  event,
  policyName,
}: {
  readonly event: FeedEvent;
  readonly policyName: string | null;
}): FeedRow | null {
  if (event.event_type === "league_policy_membership_placed") {
    if (
      !event.policy_version ||
      event.policy_version.policy.name !== policyName
    )
      return null;

    const leagueName = event.payload?.league_name ?? "the league";
    const divisionName = event.payload?.division_name;
    return {
      notice: "accepted",
      at: event.created_at,
      policyLabel: event.policy_version.label,
      text: divisionName
        ? `qualified in ${leagueName} · ${divisionName}`
        : `qualified in ${leagueName}`,
      champion: event.isChampion === true,
      href: null,
    };
  }

  const eventPolicyName =
    event.policy_version?.policy.name ?? event.payload?.policy_name ?? null;

  if (eventPolicyName === null || eventPolicyName !== policyName) return null;

  return {
    at: event.created_at,
    policyLabel: eventPolicyName,
    text: event.headline,
    champion: false,
    href: null,
  };
}
export function submissionRow({
  submission,
  policyName,
}: {
  readonly submission: FeedSubmission;
  readonly policyName: string | null;
}): FeedRow | null {
  if (
    !submission.policy_version ||
    submission.policy_version.policy.name !== policyName
  )
    return null;

  const leagueName = submission.league?.name ?? "the league";
  let text = `submitted to ${leagueName}`;

  if (submission.status === "rejected")
    text = `submission to ${leagueName} failed`;

  if (submission.status === "withdrawn") text = `withdrawn from ${leagueName}`;

  return {
    notice: submission.status === "rejected" ? "failed" : "submission",
    at: submission.created_at,
    policyLabel: submission.policy_version.label,
    text,
    champion: false,
    href: null,
  };
}
